import React from 'react'
import { SwipeableDrawer, SwipeableDrawerProps, Drawer, DrawerProps } from '@material-ui/core'
import { isIOS } from '../../common/helpers/isNative'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

// Custom interface that combines common props from both SwipeableDrawer and Drawer
interface YumDrawerProps {
  // TODO:
  PaperProps: any
  disableSwipeToClose?: boolean
  open: boolean
  onClose: () => void
  onOpen?: () => void // Required for SwipeableDrawer
  children: React.ReactNode
  // Common props that work with both components
  anchor?: 'bottom' | 'left' | 'right' | 'top'
  className?: string
  style?: React.CSSProperties
  [key: string]: any // Allow other props to be passed through
}

const YumDrawer = withStyles((theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: '#F2F2F6',
      padding: '16px', // '16px 16px 0 16px',
      borderTopLeftRadius: '24px',
      borderTopRightRadius: '24px',
      maxWidth: '500px',

      /* iOS Safari 11.2, Safari 11 */
      '@supports (bottom: constant(safe-area-inset-bottom))': {
        paddingBottom: 'calc(constant(safe-area-inset-bottom) + 16px)',
      },

      /* iOS Safari 11.4+, Safari 11.1+, Chrome 69+, Opera 56+ */
      '@supports (bottom: env(safe-area-inset-bottom))': {
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)',
      },
    },
  }),
)(({ classes, PaperProps, disableSwipeToClose, onOpen, ...props }: YumDrawerProps) => {
  // If disableSwipeToClose is true, use regular Drawer component. Replaces the deprecated
  // `disableBackdropClick` prop with the recommended onClose reason filtering (same behaviour:
  // backdrop clicks don't close the drawer, but the escape key still does).
  if (disableSwipeToClose) {
    const handleClose = (_event: object, reason?: string) => {
      if (reason === 'backdropClick') return
      if (props.onClose) (props.onClose as () => void)()
    }
    return <Drawer id="yum-drawer" classes={classes} anchor="bottom" {...props} onClose={handleClose} />
  }

  // Otherwise use SwipeableDrawer with swipe functionality
  // Provide a default onOpen function if not provided
  const handleOpen = onOpen || (() => {})

  return (
    <SwipeableDrawer
      id="yum-drawer"
      classes={classes}
      anchor="bottom"
      disableBackdropTransition={!isIOS}
      disableDiscovery={isIOS}
      disableSwipeToOpen={true}
      onOpen={handleOpen}
      PaperProps={{
        role: 'dialog',
        'aria-modal': true,
        ...PaperProps,
      }}
      {...props}
    />
  )
})

export default YumDrawer
